/// <reference types="./getEntity.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notOk, ok, } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryNoneOrOne } from '../QueryFunctions.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
import { resolveEntityFields, resolvePublishedEntityInfo } from '../utils/CodecUtils.js';
export async function publishedEntityGetOne(database, context, reference) {
    const { sql, query } = createSqliteSqlQuery();
    sql `SELECT e.uuid, e.type, e.published_name, e.auth_key, e.resolved_auth_key, e.created_at, e.invalid, ev.schema_version, ev.encode_version, ev.fields`;
    if ('id' in reference) {
        sql `FROM entities e, entity_versions ev WHERE e.uuid = ${reference.id}`;
    }
    else {
        sql `FROM entities e, entity_versions ev, unique_index_values uiv WHERE uiv.index_name = ${reference.index} AND uiv.value = ${reference.value} AND uiv.published AND uiv.entities_id = e.id`;
    }
    sql `AND e.published_entity_versions_id = ev.id`;
    const result = await queryNoneOrOne(database, context, query);
    if (result.isError())
        return result;
    if (!result.value) {
        return notOk.NotFound('No such entity');
    }
    const { uuid: id, resolved_auth_key: resolvedAuthKey } = result.value;
    assertIsDefined(id);
    return ok({
        ...resolvePublishedEntityInfo(result.value),
        ...resolveEntityFields(result.value),
        id,
        resolvedAuthKey,
    });
}
//# sourceMappingURL=getEntity.js.map